import { Injectable } from '@angular/core';
import { ActionableProcessExecutionParamsRemarks } from './model/workflow/actionable-process-execution-params-remarks.model';

@Injectable()
export class RemarkConversionService {
  public parseRemark(remark: string): ActionableProcessExecutionParamsRemarks {
    if (!remark) {
      return { Remark: '' };
    }

    try {
      const parsedJson = JSON.parse(remark);
      if (parsedJson.hasOwnProperty('Remark')) {
        return parsedJson;
      }
    } catch {}

    return { Remark: remark };
  }

  public constructRemark(value?: ActionableProcessExecutionParamsRemarks): string {
    if (value) {
      return JSON.stringify(value);
    } else {
      return JSON.stringify({ Remark: '', AssociatedFiles: [] });
    }
  }

  public isRemarkEmpty(remark: string) {
    if (!remark) {
      return true;
    }

    try {
      const parsedComment = this.parseRemark(remark);
      return !parsedComment.Remark;
    } catch {
      return true;
    }
  }
}
